import React from 'react';
import OppsBg from './../../images/NotFound.jpg'

const NotFound = () => {
    return (
        <div>
            <h1 style={{color:'red',fontWeight:'700'}}>OPPS!!! Not Found Here</h1>
            <img src={OppsBg} alt="" />
        </div>
    );
};

export default NotFound;